module.exports = __webpack_public_path__ + "static/media/table-grey.c7c892bb.png";